export default {"src":"/_next/static/media/partnerLogo.813af18d.svg","height":383,"width":384};